module.exports = __webpack_public_path__ + "static/media/freixenet@3x.147d2181.jpg";